import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-paginator',
    templateUrl: './fi-paginator.component.html',
    styleUrls: ['./fi-paginator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-paginator' },
    standalone: false,
})
export class FiPaginatorComponent {
    @Input({ required: true }) currentPage: number;
    @Input({ required: true }) totalPages: number;
    @Output() currentPageChange = new EventEmitter<number>();

    constructor(private appTextService: AppTextService) {}

    isFirstPageDisabled(): boolean {
        return this.currentPage === 1;
    }

    onFirstPageClick() {
        this.onCurrentPageChanged(1);
    }

    isLastPageDisabled(): boolean {
        return this.currentPage === this.totalPages;
    }

    onLastPageClick() {
        this.onCurrentPageChanged(this.totalPages);
    }

    isPrevPageDisabled(): boolean {
        return this.currentPage <= 1;
    }

    onPrevPageClick() {
        this.onCurrentPageChanged(this.currentPage - 1);
    }

    isNextPageDisabled(): boolean {
        return this.currentPage >= this.totalPages;
    }

    onNextPageClick() {
        this.onCurrentPageChanged(this.currentPage + 1);
    }

    private onCurrentPageChanged(newPage: number) {
        this.currentPage = newPage;
        this.currentPageChange.next(this.currentPage);
    }

    getCurrentPageText(): string {
        return this.appTextService.get('common.x_of_y', {
            '{x}': this.currentPage,
            '{y}': this.totalPages,
        });
    }
}
